import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["src", "width", "height", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.backgroundImage)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        style: _normalizeStyle({ 'background-image': `url(${_ctx.src})` }),
        class: _normalizeClass({ placeholder: _ctx.isPlaceholder })
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 6))
    : (_openBlock(), _createElementBlock("img", {
        key: 1,
        src: _ctx.src,
        class: _normalizeClass({ placeholder: _ctx.isPlaceholder }),
        width: _ctx.width,
        height: _ctx.height,
        alt: _ctx.alt
      }, null, 10, _hoisted_1))
}